module.exports = __webpack_public_path__ + "static/media/IMG_1361.2b8a3f38.jpg";